export const minLength = (minLength = 1) => ({ length = 0 } = '') => length >= minLength;
export const hasUpperCase = (password = '') => /[A-Z]/.test(password);
export const hasLowerCase = (password = '') => /[a-z]/.test(password);
export const hasDigit = (password = '') => /[0-9]/.test(password);
export const validatePassword = (password) => [minLength(8), hasUpperCase, hasLowerCase, hasDigit].every((test) => test(password));
const defaultRequirements = [
    { test: minLength(8), message: 'Use at least 8 characters' },
    { test: hasUpperCase, message: 'Use at least 1 uppercase character' },
    { test: hasLowerCase, message: 'Use at least 1 lowercase character' },
    { test: hasDigit, message: 'Use at least 1 digit' },
];
export const createPasswordValidator = (requirements = defaultRequirements) => (value) => requirements.filter(({ test }) => !test(value)).map(({ message }) => message);
export const defaultPasswordValidator = createPasswordValidator();
//# sourceMappingURL=password-validator.js.map